export const onSpaceOrEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    ;(event.code === 'Space' || event.code === 'Enter') && callback(event)
  }
